var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-input',{staticClass:"panelTitleBarSearch",attrs:{"value":_vm.value,"placeholder":_vm.i18n.search,"type":"search","icon":"magnify"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }